// Shared contact field definitions for landlord + tenant edit forms (legacy `contact`).

export const CONTACT_TEXT_FIELDS = [
  { key: "first_name", label: "First name" },
  { key: "middle_name", label: "Middle name (tussenvoegsel)" },
  { key: "last_name", label: "Last name" },
  { key: "company_name", label: "Company name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "mobile", label: "Mobile" },
  { key: "street", label: "Street" },
  { key: "house_number", label: "House number" },
  { key: "postal_code", label: "Postal code" },
  { key: "city", label: "City" },
] as const;

/** Build the contact payload from a flat form, sending null for blanks. */
export function buildContactPayload(
  form: Record<string, string>,
  kind: string,
): Record<string, unknown> {
  const out: Record<string, unknown> = { kind };
  out.title = form.title || null;
  out.gender = form.gender || null;
  for (const { key } of CONTACT_TEXT_FIELDS) out[key] = form[key] || null;
  out.language = form.language || "nl";
  return out;
}
